import React, { useEffect, useState } from "react";
import axios from "axios";

const PaymentIframe = () => {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [iframeSrc, setIframeSrc] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const noMessageTimeout = setTimeout(() => {
        if (!modalOpen) {
          setError(true);
        }
      }, 4000);

      window.parent.postMessage(
        JSON.stringify({
          type: "custom_provider_ready",
          loaded: true,
        }),
        "*"
      );

      const handleMessages = async (event) => {
        try {
          const payload = JSON.parse(event.data);
          console.log("Received payment payload:", payload);

          if (payload) {
            setError(false);
            clearTimeout(noMessageTimeout);
          }

          if (payload.invoiceId && payload.locationId) {
            setLoading(true);
            const url = `${process.env.REACT_APP_URL}/oAuth/getInvoiceData?invoiceId=${payload.invoiceId}&locationId=${payload.locationId}`;
            const response = await axios.get(url);

            const redirectionLink = response.data?.data?.link;
            if (redirectionLink) {
              openModal(redirectionLink);

              let pollingInterval = setInterval(async () => {
                const success = await hitDelayedApi(payload.invoiceId, payload.locationId);
                if (success) clearInterval(pollingInterval);
              }, 5000);
            }
            setLoading(false);
            return;
          }

          if (payload.transactionId && payload.locationId) {
            setLoading(true);
            await postTransactionData(payload);
            setLoading(false);
            return;
          }
        } catch (err) {
          console.error("Error parsing or processing message:", err);
        }
      };

      window.addEventListener("message", handleMessages);

      return () => {
        clearTimeout(noMessageTimeout);
        window.removeEventListener("message", handleMessages);
      }; 
    }, 1000);
  }, []);

  const postTransactionData = async (data) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/oAuth/paymentLink`, data);
      const redirectionLink = response.data?.data?.link;
      if (response.data.status && redirectionLink) {
        openModal(redirectionLink);

        let pollingInterval = setInterval(async () => {
          const success = await paymentLinkStatus(data.transactionId, data.locationId);
          if (success) clearInterval(pollingInterval);
        }, 5000);
      }
    } catch (err) {
      console.error("Error posting transaction data:", err);
    }
  };

  const paymentLinkStatus = async (transactionId, locationId) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/webhook/paymentLinkStatus`, {
        transactionId,
        locationId,
      });

      if (response.data.success && response.data.chargeId) {
        window.parent.postMessage(
          JSON.stringify({
            type: "custom_element_success_response",
            chargeId: `${response.data.chargeId}`,
          }),
          "*"
        );
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const hitDelayedApi = async (invoiceId, locationId) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/webhook/refundNotify`, {
        invoiceId,
        locationId,
      });

      if (response.data.success && response.data.gatewayTransactionId) {
        window.parent.postMessage(
          JSON.stringify({
            type: "custom_element_success_response",
            chargeId: `${response.data.gatewayTransactionId}`,
          }),
          "*"
        );
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  const openModal = (url) => {
    setIframeSrc(url);
    setModalOpen(true);
  };

  const reloadIframe = () => {
    setError(false);
    setModalOpen(false);
    setIframeSrc("");
    window.location.reload(); // reload iframe app
  };

  return (
    <>
      {error && (
        <div style={{ textAlign: "center", padding: "15px", color: "red" }}>
          <p>No valid payment data received.</p>
          <button
            onClick={reloadIframe}
            style={{
              padding: "5px 12px",
              background: "blue",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Reload Iframe
          </button>
        </div>
      )}

      {modalOpen && !error && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ position: "relative", width: "62%", height: "78%", background: "white" }}>
            <p
              style={{
                color: "red",
                padding: "10px",
                fontWeight: "400",
                fontSize: "13px",
                margin: "0",
                textAlign: "center",
                background: "#ff00001f",
              }}
            >
              Please do not refresh or close this page while your payment is being processed. You
              will be automatically redirected once the payment is successful.
            </p>
            <iframe src={iframeSrc} style={{ width: "100%", height: "100%", border: "none" }} />
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentIframe;
